module.exports = __webpack_public_path__ + "img/tongren_logo.46c79043.png";